import { motion } from "framer-motion"
import { useInView } from "react-intersection-observer"

const BrandDesign = () =>  {
    const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 })

    return (
        <div className="w-full mx-auto p-6 lg:px-12 lg:py-16 text-zinc-800 dark:text-zinc-200 text-sm" ref={ref}>
            <div className="grid lg:grid-cols-2 gap-12 items-center justify-between">

                <motion.div 
                    className="lg:w-10/12 space-y-6 lg:order-2"
                    initial={{ opacity: 0, x: 50 }}
                    animate={inView ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.6 }}
                >
                    <div className="flex flex-row text-zinc-800 dark:text-zinc-200 font-light items-center justify-between">
                        <div className="flex justify-start space-x-3 items-center">
                            <span className="text-purple-600 dark:text-purple-400 font-mono text-xl font-bold">01</span>
                            <span className="text-3xl lg:text-4xl font-bold text-zinc-900 dark:text-white">On-Device AI Integration</span>
                        </div>
                    </div>
                    <p className="text-zinc-600 dark:text-zinc-400 font-roboto font-light leading-relaxed">
                        Running models directly on edge devices provides zero-latency interactions, operates without active network connections, and guarantees absolute user data privacy. We specialize in configuring lightweight neural network architectures for mobile execution.
                    </p>
                    <p className="text-zinc-600 dark:text-zinc-400 font-roboto font-light leading-relaxed">
                        Leveraging Jetpack Compose, Kotlin Multiplatform (KMP), and Android's Neural Networks API, we deploy optimized vision models, on-device text embeddings, and intelligent speech processing directly on-device.
                    </p>
                </motion.div>

                <motion.div 
                    className="mx-auto lg:w-9/12 w-full lg:order-1"
                    initial={{ opacity: 0, x: -50 }}
                    animate={inView ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.6 }}
                >
                    <div className="relative mx-auto max-w-[240px] rounded-[36px] border-[6px] border-zinc-300 dark:border-slate-800 bg-slate-50 dark:bg-slate-950 p-4 shadow-[0_10px_30px_rgba(0,0,0,0.06)] dark:shadow-[0_0_40px_rgba(168,85,247,0.15)] overflow-hidden">
                        {/* Camera viewport simulation */}
                        <div className="relative aspect-[9/16] rounded-[24px] bg-zinc-100 dark:bg-slate-900 border border-zinc-200 dark:border-slate-800 overflow-hidden flex flex-col justify-between p-3">
                            <div className="flex justify-between items-center text-[10px] text-zinc-500 dark:text-zinc-400 font-mono">
                                <span>ON-DEVICE AI</span>
                                <span className="text-green-600 dark:text-green-400 animate-pulse">● LOCAL</span>
                            </div>
                            
                            {/* Bounding box simulation */}
                            <div className="border-2 border-dashed border-purple-500 rounded-lg p-2 my-auto flex flex-col justify-center items-center h-32 relative">
                                <span className="absolute -top-3 left-2 bg-purple-600 text-white font-mono text-[8px] px-1 rounded">object_detector: 98%</span>
                                <svg className="w-8 h-8 text-purple-600 dark:text-purple-400 animate-pulse" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h.01M16 12h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>

                            <div className="space-y-1 bg-white dark:bg-black p-2 rounded-lg border border-slate-200 dark:border-white/5">
                                <div className="text-[8px] text-zinc-600 dark:text-slate-400 font-mono">MODEL: MobileNetV3</div>
                                <div className="text-[8px] text-zinc-600 dark:text-slate-400 font-mono">INFERENCE: 12ms</div>
                            </div>
                        </div>
                    </div>
                </motion.div>

            </div>
        </div>
    )
}

export default BrandDesign